<template>
  <div
    class="d-flex align-items-center justify-content-around"
    :class="{ 'flex-column': !widerThan400 }"
  >
    <div class="flex-column">
      <div
        v-if="!isPastYear && !inactiveZeroBalance"
        class="d-flex justify-content-center my-3"
      >
        <div class="text-end fs-6">
          <span class="pay-bold"
            >Spring Due by
            {{ toSlashDateFormat(billingSummary.SpringDueDate) }}:</span
          >&nbsp;<br />
          <div class="mt-2">
            <span class="pay-bold"
              >Fall Due by
              {{ toSlashDateFormat(billingSummary.FallDueDate) }}:</span
            >&nbsp;
          </div>
        </div>
        <div class="text-end fs-6">
          <span class="pay-bold">{{
            formatDollarAmount(billingSummary.SpringBalanceDue) || "$0.00"
          }}</span>
          <br />
          <div class="mt-2">
            <span class="pay-bold">{{
              formatDollarAmount(billingSummary.FallBalanceDue) || "$0.00"
            }}</span>
          </div>
        </div>
      </div>
      <div
        class="d-flex flex-column align-items-center"
        :class="{
          'mt-4': imagePresent && isPastYear,
          'mt-2': !imagePresent && isPastYear,
        }"
      >
        <h3 v-if="inactiveZeroBalance" class="text-dark">INACTIVE PARCEL</h3>
        <h2 class="mb-0 lh-1">
          {{
            formatDollarAmount(billingSummary.CurrentAccountBalance) || "$0.00"
          }}
        </h2>
        <div
          class="text-muted no-padding d-flex flex-row balance-info-button"
          type="button"
          data-bs-toggle="modal"
          :data-bs-target="`#balance-info-modal`"
          title="Balance Information"
        >
          <p class="mb-0 ms-3">Total Due</p>
          &nbsp;
          <info-circle class="balance-info-circle" />
        </div>
      </div>
      <balance-info-modal id="balance-info-modal" />
    </div>
    <div class="d-flex flex-column pay-bill-button-container">
      <pay-bill-button
        class="d-print-none"
        :county="county"
        :dup="dup"
        :isFuture="isFuture"
        :currentPayYear="payYear"
        :stateKey="stateKey"
        :unformattedStateKey="unformattedStateKey"
        :currentAccountBalance="billingSummary.CurrentAccountBalance"
        :status="'ready'"
        :taxType="taxType"
        :SpringBalanceDue="billingSummary.SpringTax"
        :FallBalanceDue="billingSummary.FallTax"
        :inactiveZeroBalance="inactiveZeroBalance"
      />
      <div v-if="lteEnabled" class="dropdown-button">
        <a
          :href="lteURL"
          class="rounded flex-button mx-3 text-decoration-none button-label  d-print-none"
          :class="imagePresent ? 'm-3' : 'm-0'"
          id="file-e-forms"
          rel="noopener"
          target="_blank"
        >
          <div class="primary-link ">
            File E-Forms
          </div></a
        >
      </div>
    </div>
  </div>
</template>
<style scoped>
#file-e-forms {
  width: 11rem;
}
#image-present-pay-container {
  flex-direction: column;
}
.balance-info-button {
  cursor: pointer;
}
.balance-info-button:hover {
  text-decoration: underline;
}
.balance-info-button:hover .balance-info-circle {
  fill: #bad9d9;
}
.pay-bold {
  font-weight: 800;
}
</style>
<script>
import { formatDollarAmount } from "../../utilities.ts";
import PayBillButton from "../county/PayBillButton.vue";
import InfoCircle from "../svg/InfoCircle.vue";
import BalanceInfoModal from "./BalanceInfoModal.vue";
import { toSlashDateFormat } from "../../utilities.ts";
export default {
  components: {
    PayBillButton,
    InfoCircle,
    BalanceInfoModal,
  },
  data() {
    return {
      widerThan400: window.screen.width > 400,
    };
  },
  methods: {
    formatDollarAmount,
    toSlashDateFormat,
  },
  computed: {
    lteURL() {
      let url = process.env.VUE_APP_LTE;
      if (!url) {
        return;
      }
      url = url.replace("{{CorpCode}}", this.county.corpCode);
      url = url.replace("{{Dup}}", this.$route.params.dup);
      return url;
    },
    lteEnabled() {
      return (
        this.lteURL &&
        this.county.lteInstalled &&
        this.taxType.trim() != "Personal" &&
        this.taxType.trim() != "P" &&
        (this.parcelStatus.trim().toUpperCase() === "A" ||
          this.parcelStatus.trim().toUpperCase() === "ACTIVE")
      );
    },
    inactiveZeroBalance() {
      return (
        !this.billingSummary.CurrentAccountBalance &&
        this.parcelStatus.trim().toUpperCase() === "I"
      );
    },
  },
  props: {
    county: {
      type: Object,
      required: true,
    },
    billingSummary: {
      type: Object,
      required: true,
    },
    payYear: {
      type: Number,
      required: true,
    },
    dup: {
      type: Number,
      required: true,
    },
    isFuture: {
      type: Boolean,
      required: false,
      default: false,
    },
    isPastYear: {
      type: Boolean,
      required: false,
      default: false,
    },
    stateKey: {
      type: String,
      required: true,
    },
    unformattedStateKey: {
      type: String,
      required: true,
    },
    taxType: {
      type: String,
      required: true,
    },
    parcelStatus: {
      type: String,
      required: true,
    },
    imagePresent: {
      type: Boolean,
      required: true,
    },
  },
};
</script>
